const EN_UK = {};
export default EN_UK;
